import { useFormContext } from 'react-hook-form'
import styles from './styles.module.scss'
import { AddressData, CustomerDetailsData } from '../../../config'
import { InputErrorMessage } from '../InputField/InputErrorMessage'
import { useState } from 'react'

type CheckboxFieldProps = {
  name: string
  id: string
  required?: boolean
}

export default function CheckboxField({
  name,
  id,
  required = false
}: CheckboxFieldProps) {
  const {
    register,
    formState: { errors, defaultValues }
  } = useFormContext()
  const [isChecked, setIsChecked] = useState(
    defaultValues?.defaultAddress || false
  )
  const handleOnChange = () => {
    setIsChecked((prev: boolean) => !prev)
  }

  return (
    <label htmlFor={id} className={styles.CheckboxField}>
      <span
        className={`${styles.CheckboxFieldTick} ${
          isChecked ? styles.CheckboxFieldTick__checked : ''
        }`}
      ></span>
      <span className={`${required ? styles.CheckboxField__required : ''}`}>
        {name}
      </span>

      <input
        {...register(id)}
        id={id}
        name={id}
        type="checkbox"
        aria-label={name}
        checked={isChecked}
        onClick={handleOnChange}
      />
      {errors && (
        <InputErrorMessage
          name={id as keyof AddressData | keyof CustomerDetailsData}
          errors={errors}
        />
      )}
    </label>
  )
}
